import React from "react";
import { pluralizeWithCount } from "@common/helpers/string";
import { Form1099UnmappedAccount } from "@common/schemas/domains/tax/form1099-report.schema";
import { OverPageCTA } from "@design-system/Banner/OverPageCTA";
import { Link } from "@design-system/Link/Link";
import { StateAwareLink } from "@components/routes/StateAwareLink";

const LISTED_ACCOUNT_LIMIT = 3;

interface Props {
    unmappedAccounts: Form1099UnmappedAccount[];
    onViewMapping?: () => void;
}

export const Form1099UnmappedAccountsBanner: React.FC<Props> = ({
    unmappedAccounts,
    onViewMapping,
}) => {
    const accountNames = [
        ...new Set(unmappedAccounts.map((account) => account.accountName)),
    ];
    if (accountNames.length === 0) {
        return null;
    }

    const listedNames = accountNames.slice(0, LISTED_ACCOUNT_LIMIT);
    const remainingCount = accountNames.length - listedNames.length;
    const accountList =
        remainingCount > 0
            ? `${listedNames.join(", ")} and ${remainingCount} more`
            : listedNames.join(", ");

    const title = `${pluralizeWithCount("expense account", accountNames.length)} with 1099 vendor spend not mapped to a 1099 box`;

    return (
        <OverPageCTA
            title={
                onViewMapping ? (
                    <Link onClick={onViewMapping}>{title}</Link>
                ) : (
                    title
                )
            }
            subtitle={`${accountList}. Map them to Box 1 in the Chart of Accounts to include them in this report.`}
            cta={
                <Link
                    size="sm"
                    render={
                        <StateAwareLink to="/accounting/chart-of-accounts" />
                    }
                >
                    View Chart of Accounts
                </Link>
            }
        />
    );
};
